(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) { return; }
    
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
        
        var scripts = productRecommendationsSection.querySelectorAll('script');
        scripts.forEach(function(script) {
          var newScript = document.createElement('script');
          if (script.src) {
            newScript.src = script.src;
          } else {
            newScript.textContent = script.textContent;
          }
          document.body.appendChild(newScript);
          script.remove(); 
        });

        setTimeout(function() {
          if (typeof checkCartState === 'function') {
            checkCartState();
          }
        }, 100);
        
      }
    };
    request.send();
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });

  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
